import React from 'react';
import { inject } from 'mobx-react';

import { AxiosError } from 'axios';

import { FullHeightWrapper } from 'ui/Container';

import { CenteredCircularProgress } from 'components/Progress';

import Logger from 'utils/logger';
import { loadUploadLimits } from 'utils/uploadLimits';

import { SessionState, InjectedSessionProps } from './types';
import API from '../../utils/api';
import { isUnauthorized } from '../../utils/api/errors';

@inject('session')
export default class Session extends React.Component<{ children?: React.ReactNode }, SessionState> {
  state: SessionState = {
    isVerified: false,
  };

  componentDidMount(): void {
    loadUploadLimits();
    this.syncUser();
  }

  get injected(): InjectedSessionProps {
    return this.props as InjectedSessionProps;
  }

  syncUser = async (): Promise<void> => {
    const { session } = this.injected;

    try {
      const response = await API.user.profile()();
      session.login(response.data);
    } catch (e) {
      const err = e as AxiosError;
      if (!isUnauthorized(err)) {
        Logger.error('Invalid profile API response', err);
      }
    } finally {
      this.setState({
        isVerified: true,
      });
    }
  };

  render(): React.ReactNode {
    const { children } = this.props;
    const { isVerified } = this.state;

    if (isVerified) {
      return children;
    }
    return (
      <FullHeightWrapper>
        <CenteredCircularProgress />
      </FullHeightWrapper>
    );
  }
}
